const {
  VITE_PLATFORM_URL_BASE: PLATFORM_URL_BASE,
  VITE_CUSTOMER_OKTA_LOGOUT_URL: CUSTOMER_OKTA_LOGOUT_URL,
  VITE_CUSTOMER_OKTA_CLIENT_ID: CUSTOMER_OKTA_CLIENT_ID,
  VITE_CUSTOMER_OKTA_AUTH_URL: CUSTOMER_OKTA_AUTH_URL,
  VITE_AMCHARTS_LICENSE_CHARTS: AMCHARTS_LICENSE_CHARTS,
  VITE_AMCHARTS_LICENSE_MAPS: AMCHARTS_LICENSE_MAPS,
  VITE_AMCHARTS_LICENSE_TIMELINE: AMCHARTS_LICENSE_TIMELINE,
  VITE_HG_FORCE_SFDC_CLIENT_ID: HG_FORCE_SFDC_CLIENT_ID,
  VITE_LAUNCHDARKLY_CLIENT_SIDE_ID: LAUNCHDARKLY_CLIENT_SIDE_ID,
  VITE_SEGMENT_KEY: SEGMENT_KEY,
  VITE_AMPLITUDE_API_KEY: AMPLITUDE_API_KEY,
  VITE_MK_AUTH_SERVER_URL: MK_AUTH_SERVER_URL,
  VITE_MK_AUTH_CLIENT_ID: MK_AUTH_CLIENT_ID,
  VITE_ENVIRONMENT: ENVIRONMENT,
  VITE_ADMIN_URL: ADMIN_URL,
  VITE_STUDIO_URL: STUDIO_URL,
  VITE_COPILOT_URL: COPILOT_URL,
  VITE_MSI_URL: MSI_URL,
  VITE_HSI_URL: HSI_URL,
  VITE_EMBACK_URL: EMBACK_URL,
  VITE_BONGO_API_URL: BONGO_API_URL,
  VITE_BONGO_HGINSIGHTS_URL: BONGO_HGINSIGHTS_URL,
} = import.meta.env;

/**
 * Checks if the current hostname is under the hginsights.info domain
 */
function isHgInsightsDomain(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  return window.location.hostname.endsWith(".hginsights.info");
}

/**
 * Returns the appropriate Bongo API URL based on the current hostname.
 * Uses VITE_BONGO_HGINSIGHTS_URL if running under .hginsights.info domain,
 * otherwise uses VITE_BONGO_API_URL.
 */
function getBongoUrl(): string {
  const isHgInsights = isHgInsightsDomain();
  const hgInsightsUrl = BONGO_HGINSIGHTS_URL;
  const defaultUrl = BONGO_API_URL;

  if (isHgInsights && hgInsightsUrl) {
    return hgInsightsUrl;
  }

  return defaultUrl || "";
}

export default {
  PLATFORM_URL_BASE,
  CUSTOMER_OKTA_LOGOUT_URL,
  CUSTOMER_OKTA_CLIENT_ID,
  CUSTOMER_OKTA_AUTH_URL,
  AMCHARTS_LICENSE_CHARTS,
  AMCHARTS_LICENSE_MAPS,
  AMCHARTS_LICENSE_TIMELINE,
  HG_FORCE_SFDC_CLIENT_ID,
  LAUNCHDARKLY_CLIENT_SIDE_ID,
  SEGMENT_KEY,
  AMPLITUDE_API_KEY,
  MK_AUTH_SERVER_URL,
  MK_AUTH_CLIENT_ID,
  ADMIN_URL,
  STUDIO_URL,
  COPILOT_URL,
  MSI_URL,
  HSI_URL,
  EMBACK_URL,
  BONGO_API_URL,
  BONGO_HGINSIGHTS_URL,
  getBongoUrl,
  IS_PROD: ENVIRONMENT === "production",
  IS_STAGING: ENVIRONMENT === "staging",
  IS_DEV: ENVIRONMENT === "development",
};
